'use strict';

// Abrir Chamado Controller

var abrirChamadoMdl = angular.module('abrirChamadoMdl');
abrirChamadoMdl.controller('abrirChamadoCtrl', abrirChamadoCtrl);

abrirChamadoCtrl.$inject = [    
    '$state',
    '$stateParams',
    'Event',
    'notificacao',
    'categorizacoesApi',
    'chamadosApi',
    '$sessionStorage'
];

function abrirChamadoCtrl(
    $state,
    $stateParams,
    Event,
    notificacao,
    categorizacoesApi,
    chamadosApi,
    $sessionStorage) {

    var $ctrl = this;

    // Objetos e Propriedades
    $ctrl.data = new Date();
    $ctrl.chamado = {};
    $ctrl.segmentoParametros = $stateParams;
    $ctrl.abrirChamado = abrirChamado;
    $ctrl.colar = colar;
    $ctrl.api = null;
    $ctrl.unidades = [];    
    var credencial = $sessionStorage.credencial.data.credencial;

    categorizacoesApi.listarImpactos(function (impactos) {
        $ctrl.impactos = impactos;
    }, function (erros) {
        notificacao.erroResponse(erros);
    });

    categorizacoesApi.listarUrgencias(function (urgencias) {
        $ctrl.urgencias = urgencias;
    }, function (erros) {
        notificacao.erroResponse(erros);
    });

    /**
     * Abre chamado para o usuário.
     * 
     * @param object chamado
     */
    function abrirChamado(chamado) {

        var formChamado = new FormData();

        formChamado.append('grupoDeSuporteSegmentoId', $stateParams.grupoDeSuporteSegmentoId);
        formChamado.append('aberturaAssunto', chamado.assunto);
        formChamado.append('impactoSolicitanteId', chamado.impactoSolicitante.impactoId);
        formChamado.append('urgenciaSolicitanteId', chamado.urgenciaSolicitante.urgenciaId);        
        formChamado.append('aberturaUnidade', chamado.aberturaUnidade);
        formChamado.append('aberturaMensagem', _.escape(chamado.mensagem.replace(/'/g, '"')));

        _.each(chamado.anexos, function (anexo) {
            formChamado.append('Files[]', anexo, anexo.name);
        });

        $ctrl.api = chamadosApi.abrirChamado(formChamado,
            function (response) {

                notificacao.sucesso(
                    '<i class="fa fa-ticket" style="color: #ffffff;"></i> Ticket de Abertura de Chamado',
                    'Chamado registrado com o Ticket Nº. ' + response.ticket);

                $state.go('app.meus-chamados');
            },
            function (erros) {
                
                if (erros.data) {
                    notificacao.erroResponse(erros);
                } else {
                    notificacao.erro('Erro durante o envido do chamado, por gentileza tente novamente.');
                }

            }
        ).$promise;

    }
    chamadosApi.unidades(function (unidades) {
        $ctrl.unidades = unidades;
        $ctrl.chamado.aberturaUnidade =  credencial.registroAd.unidade;
        
    }, function (erros) {
        notificacao.erroResponse(erros);
    });
    /**
     * Ouvinte para o evento colar no formulario
     * de abertura de chamado
     * 
     * @param object $event
     */
    function colar($event) {
   
        Event.fire('anexo.colar-arquivo', $event );

    }

}


// WEBPACK FOOTER //
// ./src/modules/abrir-chamado/abrir-chamado-controller.js